const LiverampLogo = '/LiveRamp.png';

export default function DestinationPartnerIcon({ slug, size = null }) {
  let props = {};
  if (size) {
    props.size = size;
  }
  // LiveRamp is seeded as 5 folder variants (`liveramp-<folder>`); they all
  // share the same LiveRamp logo. Match on prefix before the switch so we
  // don't need a case per variant.
  if (slug && slug.startsWith('liveramp')) {
    return <LiverampIcon {...props} />;
  }
  switch (slug) {
    case 'meta':
      return <MetaIcon {...props} />;
    case 'google-ads':
      return <GoogleAdsIcon {...props} />;
    case 'tiktok-ads':
      return <TokTokIcon {...props} />;
    case 'linkedin-ads':
      return <LinkedInIcon {...props} />;
    case 'amazon-dsp':
      return <AwsIcon {...props} />;
    case 'the-trade-desk':
      return <TradeDeskIcon {...props} />;
    case 'snowflake':
      return <SnowflakeIcon {...props} />;
    case 's3':
      return <S3Icon {...props} />;
    case 'sftp':
      return <SftpIcon {...props} />;
    default:
      return null;
  }
}

const MetaIcon = ({ size = 24, color = 'currentColor', className = '' }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.217 5.243C9.145 3.988 10.171 3 11.483 3 13.96 3 16 6.153 16.001 9.907c0 2.29-.986 3.725-2.757 3.725-1.543 0-2.395-.866-3.924-3.424l-.667-1.123-.118-.197a54.944 54.944 0 0 0-.53-.877l-1.178 2.08c-1.673 2.925-2.615 3.541-3.923 3.541C1.086 13.632 0 12.217 0 9.973 0 6.388 1.995 3 4.598 3c.319 0 .625.039.924.122.31.086.611.22.913.407.577.359 1.154.915 1.782 1.714Zm1.516 2.224c-.252-.41-.494-.787-.727-1.133L9 6.326c.845-1.305 1.543-1.954 2.372-1.954 1.723 0 3.102 2.537 3.102 5.653 0 1.188-.39 1.877-1.195 1.877-.773 0-1.142-.51-2.61-2.87l-.937-1.565ZM4.846 4.756c.725.1 1.385.634 2.34 2.001A212.13 212.13 0 0 0 5.551 9.3c-1.357 2.126-1.826 2.603-2.581 2.603-.777 0-1.24-.682-1.24-1.9 0-2.602 1.298-5.264 2.846-5.264.091 0 .181.006.27.018Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

function TokTokIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      viewBox="0 0 448 512"
      width={size}
      height={size}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
    </svg>
  );
}

const AwsIcon = ({ size = 24, color = 'currentColor', className = '' }) => {
  return (
    <svg
      viewBox="0 0 640 512"
      width={size}
      height={size}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z" />
    </svg>
  );
};

const GoogleAdsIcon = ({ size = 24, className = '' }) => {
  return (
    <svg
      viewBox="0 0 512 512"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#febd00"
        d="M202.33,53.44a80.7,80.7,0,0,0-18.8,22.06L22.29,353.58A81.62,81.62,0,0,0,51.87,464.8h0a81.62,81.62,0,0,0,111.22-29.58l138.59-239C271.1,152.32,226.49,88.29,202.33,53.44Z"
      />
      <circle fill="#25a84a" cx="92.69" cy="394.4" r="81.38" />
      <rect
        fill="#2e8add"
        height="484.21"
        rx="81.38"
        ry="81.38"
        transform="translate(751.31 309.71) rotate(150)"
        width="162.76"
        x="252.78"
        y="13.4"
      />
    </svg>
  );
};

const LinkedInIcon = ({ size = 24, className = '' }) => {
  return (
    <svg
      viewBox="0 0 512 512"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="g5891">
        <path
          d="M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z"
          style={{ fill: '#2867b2' }}
        />
        <g id="shapes">
          <rect
            height="257.962"
            width="85.76"
            x="61.053"
            y="178.667"
            style={{ fill: '#fff' }}
          />
          <path
            d="M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z"
            style={{ fill: '#fff', fillRule: 'nonzero' }}
          />
          <path
            d="M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z"
            style={{ fill: '#fff', fillRule: 'nonzero' }}
          />
        </g>
      </g>
    </svg>
  );
};

const TradeDeskIcon = ({ size = 24, className = '' }) => {
  return (
    <svg
      viewBox="0 0 62.5 66"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <style type="text/css">{`.st0{fill:#0099FA;}`}</style>
      <g>
        <g>
          <polygon
            className="st0"
            points="15.7,0 15.7,10.3 26.2,10.3 26.2,37.1 36.3,37.1 36.3,10.1 36.3,0"
          />
          <g>
            <path
              className="st0"
              d="M10.1,34.7c0-8,4.4-15,11-18.6v0h-15C2.3,21.4,0,27.8,0,34.7c0,13.8,8.9,25.5,21.3,29.7v-11 C14.7,49.8,10.1,42.8,10.1,34.7"
            />
            <path
              className="st0"
              d="M41.4,5.2v11c6.6,3.6,11,10.6,11,18.6c0,11.7-9.5,21.1-21.1,21.1c-1.7,0-3.4-0.2-5.1-0.6v10.3 c1.6,0.3,3.3,0.4,5.1,0.4c17.3,0,31.3-14,31.3-31.3C62.5,21,53.7,9.4,41.4,5.2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const LiverampIcon = ({ size = 30, className = '' }) => {
  return (
    <img
      src={LiverampLogo}
      alt="Liveramp Logo"
      width={size}
      height={size}
      className={className}
    />
  );
};

const SnowflakeIcon = ({ size = 24, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 146.36 139.16"
      className={className}
      width={size}
      height={size}
    >
      <path
        fill="#29b5e8"
        className="cls-1"
        d="M134.81,60.1l-16.47,9.49L134.81,79a8.65,8.65,0,1,1-8.67,15l-29.51-17a8.68,8.68,0,0,1-4.33-7.75,8.48,8.48,0,0,1,.31-2,8.68,8.68,0,0,1,4-5.19l29.51-16.94A8.69,8.69,0,0,1,138,48.31,8.58,8.58,0,0,1,134.81,60.1Zm-15.59,46L89.72,89.13a8.72,8.72,0,0,0-13.06,7.48v33.9a8.69,8.69,0,0,0,17.37,0v-19L110.54,121a8.66,8.66,0,1,0,8.68-15Zm-34-33.16L72.92,85.09a2.44,2.44,0,0,1-1.54.65H67.77a2.51,2.51,0,0,1-1.54-.65L54,72.9a2.45,2.45,0,0,1-.64-1.52v-3.6A2.5,2.5,0,0,1,54,66.25L66.23,54.06a2.5,2.5,0,0,1,1.54-.64h3.61a2.45,2.45,0,0,1,1.54.64L85.18,66.25a2.49,2.49,0,0,1,.63,1.53v3.6A2.44,2.44,0,0,1,85.18,72.9Zm-9.8-3.38A2.59,2.59,0,0,0,74.73,68l-3.55-3.51a2.51,2.51,0,0,0-1.54-.64h-.13a2.46,2.46,0,0,0-1.53.64L64.43,68a2.51,2.51,0,0,0-.63,1.55v.13a2.41,2.41,0,0,0,.63,1.52L68,74.7a2.48,2.48,0,0,0,1.53.64h.13a2.51,2.51,0,0,0,1.54-.64l3.55-3.53a2.49,2.49,0,0,0,.65-1.52ZM19.93,33.08,49.44,50a8.73,8.73,0,0,0,13.07-7.49V8.64a8.69,8.69,0,0,0-17.37,0v19l-16.53-9.5a8.65,8.65,0,1,0-8.68,15ZM84.69,51.16a8.64,8.64,0,0,0,5-1.13l29.5-17a8.65,8.65,0,1,0-8.68-15L94,27.61v-19a8.69,8.69,0,0,0-17.37,0v33.9A8.66,8.66,0,0,0,84.69,51.16ZM54.48,88a8.58,8.58,0,0,0-5,1.13L19.93,106.06a8.66,8.66,0,1,0,8.68,15l16.53-9.49v19a8.69,8.69,0,0,0,17.37,0V96.61A8.65,8.65,0,0,0,54.48,88Zm-8-15.87a8.61,8.61,0,0,0-4-10L13,45.14A8.69,8.69,0,0,0,1.17,48.31,8.59,8.59,0,0,0,4.35,60.1l16.47,9.49L4.35,79A8.65,8.65,0,1,0,13,94l29.48-17A8.59,8.59,0,0,0,46.47,72.13Zm93.15-56.22H138.3v1.63h1.32c.61,0,1-.28,1-.8S140.26,15.91,139.62,15.91Zm-2.94-1.5h3c1.62,0,2.7.89,2.7,2.27a2.16,2.16,0,0,1-1.08,1.9l1.17,1.68v.34h-1.69L139.62,19H138.3V20.6h-1.62Zm8.3,3.22a5.48,5.48,0,0,0-5.58-5.83c-3.31,0-5.51,2.39-5.51,5.83,0,3.28,2.2,5.82,5.51,5.82A5.47,5.47,0,0,0,145,17.63Zm1.38,0c0,3.89-2.6,7.14-7,7.14s-6.89-3.28-6.89-7.14,2.57-7.14,6.89-7.14S146.36,13.73,146.36,17.63Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

const S3Icon = ({ size = 24, className = '' }) => {
  return (
    <svg
      viewBox="0 0 256 310"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#9D5025"
        d="M20.486 61.132c-2.329-1.364-2.329-3.583 0-4.947L108.8 5.28c6.987-4.095 18.413-4.095 25.4 0l88.314 50.905c2.329 1.364 2.329 3.583 0 4.947L134.2 112.037c-6.987 4.095-18.413 4.095-25.4 0L20.486 61.132z"
      />
      <path
        fill="#F58536"
        d="M20.486 61.132v50.905c0 2.783 3.016 4.547 5.345 3.183L134.2 64.315c6.987-4.095 18.413-4.095 25.4 0l108.369 50.905c2.329 1.364 5.345-.4 5.345-3.183V61.132c0-2.783-3.016-4.547-5.345-3.183L159.6 108.854c-6.987 4.095-18.413 4.095-25.4 0L25.831 57.949c-2.329-1.364-5.345.4-5.345 3.183z"
      />
      <path
        fill="#9D5025"
        d="M20.486 163.942c-2.329-1.364-2.329-3.583 0-4.947L108.8 108.09c6.987-4.095 18.413-4.095 25.4 0l88.314 50.905c2.329 1.364 2.329 3.583 0 4.947L134.2 214.847c-6.987 4.095-18.413 4.095-25.4 0l-88.314-50.905z"
      />
      <path
        fill="#F58536"
        d="M20.486 163.942v50.905c0 2.783 3.016 4.547 5.345 3.183L134.2 167.125c6.987-4.095 18.413-4.095 25.4 0l108.369 50.905c2.329 1.364 5.345-.4 5.345-3.183v-50.905c0-2.783-3.016-4.547-5.345-3.183L159.6 211.664c-6.987 4.095-18.413 4.095-25.4 0L25.831 160.759c-2.329-1.364-5.345.4-5.345 3.183z"
      />
      <path
        fill="#9D5025"
        d="M20.486 266.752c-2.329-1.364-2.329-3.583 0-4.947L108.8 210.9c6.987-4.095 18.413-4.095 25.4 0l88.314 50.905c2.329 1.364 2.329 3.583 0 4.947L134.2 317.657c-6.987 4.095-18.413 4.095-25.4 0l-88.314-50.905z"
      />
      <path
        fill="#F58536"
        d="M20.486 266.752v50.905c0 2.783 3.016 4.547 5.345 3.183L134.2 269.935c6.987-4.095 18.413-4.095 25.4 0l108.369 50.905c2.329 1.364 5.345-.4 5.345-3.183v-50.905c0-2.783-3.016-4.547-5.345-3.183L159.6 314.474c-6.987 4.095-18.413 4.095-25.4 0L25.831 263.569c-2.329-1.364-5.345.4-5.345 3.183z"
      />
    </svg>
  );
};

const SftpIcon = ({ size = 24, className = '' }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      <path d="M4 6h16v2H4zm0 4h16v2H4zm0 4h16v2H4z" opacity="0.3"/>
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h16v2H4V6zm0 4h16v2H4v-2zm0 4h16v2H4v-2z"/>
    </svg>
  );
};
